import locale77427e78 from '../../src/locales/en.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"en"},
  vueI18nLoader: false,
  locales: [{"name":"English","code":"en","iso":"en-CA","file":"en.js"},{"name":"Français","code":"fr","iso":"fr-CA","file":"fr.js"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales/",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":true,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":".fourwaves.com","cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"en","redirectOn":"all","useCookie":true},
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: false,
  pages: {"_slug/index":{"en":"/:slug","fr":"/:slug"},"_slug/registration/index":{"en":"/:slug/registration","fr":"/:slug/inscription"},"_slug/registration/billing":{"en":"/:slug/registration/billing","fr":"/:slug/inscription/facturation"},"_slug/registration/confirmation":{"en":"/:slug/registration/confirmation","fr":"/:slug/inscription/confirmation"},"_slug/submission/index":{"en":"/:slug/submission","fr":"/:slug/soumission"},"_slug/submission/billing":{"en":"/:slug/submission/billing","fr":"/:slug/soumission/facturation"},"_slug/submission/confirmation":{"en":"/:slug/submission/confirmation","fr":"/:slug/soumission/confirmation"},"_slug/pages/_id":{"en":"/:slug/pages/:id?","fr":"/:slug/pages/:id?"},"_slug/abstracts/index":{"en":"/:slug/abstracts","fr":"/:slug/resumes"},"_slug/abstracts/_id":{"en":"/:slug/abstracts/:id","fr":"/:slug/resumes/:id"},"_slug/abstracts/_id/poster":{"en":"/:slug/abstracts/:id/poster","fr":"/:slug/resumes/:id/affiche"},"_slug/abstracts/_id/slides":{"en":"/:slug/abstracts/:id/slides","fr":"/:slug/resumes/:id/diapositives"},"_slug/abstracts/_id/video":{"en":"/:slug/abstracts/:id/video","fr":"/:slug/resumes/:id/video"},"_slug/abstracts/_id/figures":{"en":"/:slug/abstracts/:id/figures","fr":"/:slug/resumes/:id/figures"},"_slug/participants/index":{"en":"/:slug/participants","fr":"/:slug/participants"},"_slug/participants/_id":{"en":"/:slug/participants/:id","fr":"/:slug/participants/:id"},"_slug/schedule/index":{"en":"/:slug/schedule","fr":"/:slug/horaire"},"_slug/schedule/_id":{"en":"/:slug/schedule/:id","fr":"/:slug/horaire/:id"},":slug/errors/:id":{"en":"/:slug/errors/:code","fr":"/:slug/erreurs/:code?"}},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"name":"English","code":"en","iso":"en-CA","file":"en.js"},{"name":"Français","code":"fr","iso":"fr-CA","file":"fr.js"}],
  localeCodes: ["en","fr"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "e",
  3: "n",
  4: ".",
  5: "j",
  6: "s",
  7: "\"",
  8: ":",
  9: "\"",
  10: ".",
  11: ".",
  12: "/",
  13: "s",
  14: "r",
  15: "c",
  16: "/",
  17: "l",
  18: "o",
  19: "c",
  20: "a",
  21: "l",
  22: "e",
  23: "s",
  24: "/",
  25: "e",
  26: "n",
  27: ".",
  28: "j",
  29: "s",
  30: "\"",
  31: ",",
  32: "\"",
  33: "f",
  34: "r",
  35: ".",
  36: "j",
  37: "s",
  38: "\"",
  39: ":",
  40: "\"",
  41: ".",
  42: ".",
  43: "/",
  44: "s",
  45: "r",
  46: "c",
  47: "/",
  48: "l",
  49: "o",
  50: "c",
  51: "a",
  52: "l",
  53: "e",
  54: "s",
  55: "/",
  56: "f",
  57: "r",
  58: ".",
  59: "j",
  60: "s",
  61: "\"",
  62: "}",
}

export const localeMessages = {
  'en.js': () => Promise.resolve(locale77427e78),
  'fr.js': () => import('../../src/locales/fr.js' /* webpackChunkName: "lang-fr.js" */),
}
